import type {
  AgentTraits,
  AnalyticsAdapter,
  AnalyticsConfig,
  AnalyticsPageViewProperties,
  AnalyticsTrackProperties,
} from './analyticsAdapter.ts'

/**
 * Logs all analytics calls to console - useful for local development.
 */
export class ConsoleAnalyticsAdapter implements AnalyticsAdapter {
  private isInitialized = false
  private log = console.info.bind(console)

  initialize(config: AnalyticsConfig): void {
    if (this.isInitialized) return
    this.isInitialized = true

    this.log('[Analytics] Initialized (console adapter):', config)
  }

  identify(agentId: string, traits?: AgentTraits): void {
    // Log the raw payload passed to `identify()` (do not merge/transform).
    this.log('[Analytics] identify(agent):', { agentId, traits })
  }

  track(eventName: string, properties?: AnalyticsTrackProperties): void {
    this.log('[Analytics] track:', { event: eventName, properties })
  }

  pageView(screenName: string, properties?: AnalyticsPageViewProperties): void {
    this.log('[Analytics] pageView:', { screenName, properties })
  }

  reset(): void {
    this.log('[Analytics] reset: Agent identity cleared')
  }
}
